import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { getDevicesList, deleteDevices, devicesCheckDelete } from '@blade-sxp/pass/api/access-management/device-management';
import { filter, map, some } from 'lodash';
let default_1 = class default_1 extends Vue {
    groupId;
    deviceId;
    deviceTypeList;
    onDeviceTypeList() {
        this.getDevicesList();
        this.getFilterType();
    }
    dialogVisible = false;
    chooseList = [];
    devicesList = [];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    deviceStatusList = [];
    confirm = '';
    deviceConfirmDelete = '';
    filterStatus = [];
    filterType = [];
    filterTypeValues = [];
    initI18n() {
        this.filterStatus = [
            { text: this.$t('online'), value: 1 },
            { text: this.$t('offline'), value: 0 },
            { text: this.$t('abnormal'), value: 2 },
        ];
    }
    getFirstKey(obj) {
        for (let key in obj) {
            return key;
        }
    }
    getFilterType() {
        const selectList = some(this.deviceTypeList, item => item.status)
            ? filter(this.deviceTypeList, item => item.status)
            : this.deviceTypeList;
        this.filterType = map(selectList, item => ({ text: item.description, value: item.deviceType }));
    }
    handleFilterChange(filters) {
        // debugger
        if (filters.status) {
            this.deviceStatusList = filters.status;
            this.getDevicesList();
        }
        else if (filters.type) {
            this.filterTypeValues = filters.type;
            this.getDevicesList();
        }
    }
    /**
     *@Description: 删除设备
     *@Date: 2020-09-10 18:16:47
     */
    handleDelete(sid) {
        // this.confirm = `${this.$t('common.confirm')}`;
        this.deviceConfirmDelete = `${this.$t('deleteConfirmMsg')}`;
        this.$alert(this.deviceConfirmDelete, {
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            callback: (action) => {
                if (action === 'confirm') {
                    this.handleDevicesCheckDelete(sid);
                }
            },
        });
    }
    handleDeleteDevices(deviceId) {
        deleteDevices(deviceId).then((res) => {
            this.$message({ message: res.data.message, type: 'success' });
            this.getDevicesList();
            this.$emit('refreshSummary');
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handleDevicesCheckDelete(deviceId) {
        devicesCheckDelete(deviceId).then((res) => {
            if (res?.data?.data?.check) {
                this.handleDeleteDevices(deviceId);
            }
            else {
                this.$alert(res.data.data.message, {
                    confirmButtonText: this.$t('common.confirm').toString(),
                    callback: (action) => {
                        // if (action === 'confirm') {
                        //   // this.handleDevicesCheckDelete(sid);
                        // }
                    },
                });
                // this.$message({
                //   message: res.data.data.message,
                //   type: 'error',
                // });
            }
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handleSelectionChange(e) {
        console.log(e);
        this.chooseList = e;
    }
    handleSelectAll(e) {
        console.log(e);
        this.chooseList = e;
    }
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getDevicesList();
    }
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getDevicesList();
    }
    handelRemove() {
        this.dialogVisible = true;
    }
    handleDetail(deviceId) {
        this.$router.push({ path: '/traffic/device/detail', query: { deviceId: deviceId } });
    }
    getDevicesList() {
        const selectTypeList = this.filterTypeValues.length
            ? this.filterTypeValues
            : this.deviceTypeList?.filter(item => item.status)?.map(item => item.deviceType);
        const data = {
            deviceId: this.deviceId,
            deviceStatusList: this.deviceStatusList,
            deviceTypeList: selectTypeList,
            groupId: this.groupId,
            page: this.pagination.page,
            size: this.pagination.size,
        };
        getDevicesList(data).then((resp) => {
            this.devicesList = resp?.data?.data?.list || [];
            this.pagination.total = resp?.data?.data?.total;
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    initFilters() {
        this.getFilterType();
        this.filterStatus = [
            { text: this.$t('online'), value: 1 },
            { text: this.$t('offline'), value: 0 },
            { text: this.$t('abnormal'), value: 2 },
        ];
    }
    mounted() {
        this.getDevicesList();
        this.initFilters();
    }
    changeGroupId(val) {
        console.log(this.groupId);
        this.getDevicesList();
    }
};
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceTypeList", void 0);
__decorate([
    Watch('deviceTypeList')
], default_1.prototype, "onDeviceTypeList", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
__decorate([
    Watch('groupId')
], default_1.prototype, "changeGroupId", null);
default_1 = __decorate([
    Component({
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    online: 'Online',
                    offline: 'Offline',
                    abnormal: 'Abnormal',
                    deleteConfirmMsg: 'After the device is deleted, all portrait data and traffic records in the device will be deleted, and the device will be restored to factory settings. Please operate with caution. (Cloud data will be retained)',
                },
                zh: {
                    online: '在线',
                    offline: '离线',
                    abnormal: '设备异常',
                    deleteConfirmMsg: '设备删除后，将删除所有设备内的人像数据及通行记录，同时设备端恢复出厂设置，请谨慎操作。（云端数据将保留）',
                },
            },
        },
    })
], default_1);
export default default_1;
